import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconProp } from 'models/Icon';

import './LeadCardTag.styles.scss';

type LeadCardTagProps = {
  className?: string;
  label: string;
  alert?: boolean;
  danger?: boolean;
  success?: boolean;
  info?: boolean;
  Icon?: IconProp;
};

const LeadCardTag: React.FC<LeadCardTagProps> = (props) => {
  const { className, label, alert, danger, success, info, Icon } = props;

  const classes = classNames(
    'lead-card-tag',
    { alert, success, info, danger },
    className,
  );

  const { t } = useTranslation();

  return (
    <p key={label} className={classes}>
      {t(label)}
      {Icon && <Icon />}
    </p>
  );
};

export default LeadCardTag;
